import React from 'react';

export default function FloatingActions({ cartCount, onOpenCart, onWhatsApp }) {
  return (
    <>
      <button
        type="button"
        className="floating-cart"
        onClick={onOpenCart}
        aria-label="Open enquiry list"
        title="Open enquiry list"
      >
        Enquiry{cartCount ? ` (${cartCount})` : ''}
      </button>

      <button
        type="button"
        className="floating-whatsapp"
        onClick={onWhatsApp}
        aria-label="Message us on WhatsApp"
        title="Message us on WhatsApp"
      >
        Message us
      </button>
    </>
  );
}
